import React, { useEffect } from "react";
import { AuthContext } from "../context/AuthContext";
import { useHistory } from "react-router-dom";
import TplInspectorFormBody from "../components/tpl-inspection/inspectorForm";

export default function TplInspectionFormOnline() {
  const { user } = React.useContext(AuthContext);
  const history = useHistory();

  // useEffect(() => {
  //     document.title = 'Inspection Form | FameWheels';
  //     if (!user) {
  //         history.push("/")
  //       }
  //   }, []);
  return (
    <>
      <TplInspectorFormBody />
    </>
  );
}
